import React, { useEffect, useState, useRef } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { Form } from 'antd'
import { IoAddCircleOutline, IoRemoveCircle } from 'react-icons/io5'

import DataTable from 'Shared/Components/DataTable'
import PopupModal from 'Shared/Components/PopupModal'
import { Dropdown, FormContainer } from 'Shared/Components/FormComponents'
import { showSuccess } from 'Shared/Components/NotifyToast'
import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'

const SmartwatchConfinedSpaceStandbyPerson = () => {
  const { role, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()

  const [data, setData] = useState()
  const [workers, setWorkers] = useState([])
  const [formOpen, setFormOpen] = useState(false)

  const [form] = Form.useForm()

  const tableRef = useRef()

  const loadData = async () => {
    tableRef.current.setTableLoading(true)

    const body = await send({
      method: "GET",
      url: `${apiUrl}/smartwatch/standby_person`,
      params: {
        "standby_person": 1
      },
      returnType: "json"
    })

    body && setData(body)

    tableRef.current.setTableLoading(false)
  }

  const getAvailableWorkers = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/smartwatch/standby_person`,
      params: {
        "standby_person": 0
      },
      returnType: "json"
    })

    body && setWorkers(body)
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await Promise.all([
        loadData()
      ])

      setPageLoading(false)
    }

    init()    
  }, [])

  const updateAssignment = async (worker_id, status) => {
    setPageLoading(true)

    const res = await send({
      method: "PUT",
      url: `${apiUrl}/smartwatch/${status ? "assign_standby_person" : "deassign_standby_person"}/${worker_id}`,
      contentType: "json"
    })

    if (res != null) {
      showSuccess(t("general_success"))

      await loadData()
    }

    setPageLoading(false)
  }

  const toggleForm = async () => {
    if (!formOpen) {
      setPageLoading(true)

      await getAvailableWorkers()

      setPageLoading(false)
    }
    else {
      form.resetFields()
    }
    
    setFormOpen(!formOpen)
  }

  const onFinish = async (values) => {
    await updateAssignment(values["worker_id"], true)

    toggleForm()
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ display: "flex", flexFlow: "column", height: "100%" }}>
            <DataTable
              data={data} count={null} ref={tableRef}
              columns={{
                "worker_name": { "label": t("general_workerName"), "sorting": false, "nowrap": true },
              }}
              appActions={() => { return [
                (["pm", "admin"].includes(role)) && {icon: <IoAddCircleOutline size={20}/>, text: t("general_add"), onClick: function(row) { toggleForm() }},
              ]}}
              renderActions={(row) => { return [
                ["pm", "admin"].includes(role) && {icon: <IoRemoveCircle size={20}/>, text: t("general_edit"), onClick: function(row) { updateAssignment(row["worker_id"], false) }},
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 

    <PopupModal isOpen={formOpen} close toggle={() => toggleForm()} width="80%">
      <FormContainer form={form} onFinish={onFinish}>
        <Dropdown field_name={t("smartwatch_worker")} field_id="worker_id" props={{ "options": workers.map((i) => ({ "value": i["worker_id"], "label": i["worker_name"] })) }}/>
      </FormContainer>
    </PopupModal>
  </>)
}

export default SmartwatchConfinedSpaceStandbyPerson
